var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllReset(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.033 24.725",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68",
    d: "M0 13.08c0-.42.479-.762 1.069-.762H18.93c.591 0 1.069.342 1.069.762s-.479.76-1.069.76H1.065C.479 13.84 0 13.497 0 13.08z",
    fill: "#f07122"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 69",
    d: "M0 19.239c0-.42.239-.762.535-.762h8.93c.3 0 .535.342.535.762s-.239.76-.535.76H.535c-.296 0-.535-.34-.535-.76z",
    fill: "#f07122"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 70",
    d: "M0 6.923c0-.42.479-.76 1.069-.76H18.93c.591 0 1.069.34 1.069.76s-.479.76-1.069.76H1.065C.479 7.679 0 7.339 0 6.923z",
    fill: "#f07122"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "M0 .76C0 .34.479 0 1.069 0H18.93c.591 0 1.069.34 1.069.76s-.479.762-1.069.762H1.065C.479 1.522 0 1.18 0 .76z",
    fill: "#f07122"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 585",
    d: "M19.461 18.435a4.15 4.15 0 00-2.549-1.931 4.164 4.164 0 00-2-.029l.295-.558a.441.441 0 00-.184-.6.441.441 0 00-.6.184l-.85 1.61-.009.019-.008.017-.009.026a.247.247 0 00-.008.025v.02c0 .007 0 .025-.006.037a.24.24 0 000 .026.22.22 0 000 .023v.086c0 .009 0 .024.008.036a.237.237 0 00.006.024c0 .007.005.015.008.021l.016.038.006.013.009.017.013.019.015.021.018.023.015.017.027.026.021.018.018.013.025.016.024.015.02.009 1.719.7a.438.438 0 00.165.032.439.439 0 00.409-.276.441.441 0 00-.243-.573l-.682-.276a3.275 3.275 0 011.538.032 3.276 3.276 0 012.011 1.524 3.275 3.275 0 01.343 2.5 3.275 3.275 0 01-1.522 2.012 3.3 3.3 0 01-4.511-1.179.441.441 0 00-.6-.157.441.441 0 00-.158.6 4.2 4.2 0 003.611 2.065 4.169 4.169 0 002.1-.572 4.182 4.182 0 001.499-5.713z",
    fill: "#f0711f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllReset);
export default ForwardRef;